export interface PaginationInterface {
    totalResults: number;
    pageSize: number;
    page: number;
    totalPages: number;
}

export const paginationPageParameter = 'page';
